import { Form, Input, Row, Col, Switch, Select, DatePicker, InputNumber } from 'antd';
import { useRef, useEffect, useState } from 'react';
import WebEditUniversal, { WebEditUniversalProps } from '../../system/WebEditUniversal';
import getList from '../../../utilsTsx/universal/getList';
import fetchApi from '../../../utilsTsx/components/system/fetchApi';

/**
 * 获取会员级别数据
 * @param apiVariable 
 * @param currentService 
 * @param setMembershipLevelData 
 */
export const getMembershipLevelData = (
    apiVariable: string,
    currentService: string,
    setMembershipLevelData: Function
) => {
    fetchApi.GET(currentService,
        {
            query: {
                apiId: 'membershipLevel',
                apiExtend: 'showList',
                apiVariable
            }
        }).then(res => {
            if (res.success) {
                setMembershipLevelData(res.data);
            }
        });
};

const EditComponent = (props: any) => {
    const [form] = Form.useForm();
    const apiId = 'membershipRechargePlans';
    const { editMode, defaultService } = props;
    const ref = useRef<any>(undefined);
    const [membershipTypeData, setMembershipTypeData] = useState<any>();
    const [membershipLevelData, setMembershipLevelData] = useState<any>();
    const [rechargeCategoryData, setRechargeCategoryData] = useState<any>();
    const [membershipPointsPlansData, setMembershipPointsPlansData] = useState<any>();
    const [membershipRechargeLockRulesData, setMembershipRechargeLockRulesData] = useState<any>();
    const [permanentUseDisabled, setPermanentUseDisabled] = useState<boolean>(false);

    useEffect(() => {
        if (ref.current) {
            ref.current.getRow.then((res: any) => {
                if (res?.success === true) {
                    setPermanentUseDisabled(res.data.isPermanentUse);
                    getMembershipLevelData(res.data.membershipTypeId,
                        defaultService,
                        setMembershipLevelData);
                }
            })
        }
        fetchApi.GET(defaultService,
            {
                query: {
                    apiId: 'generalData',
                    apiVariable: 'rechargeCategory',
                    apiExtend: 'showLists'
                }
            }).then(res => {
                if (res.success) {
                    const { rechargeCategory } = res.data;
                    setRechargeCategoryData(rechargeCategory);;
                }
            });
        fetchApi.GET(defaultService,
            {
                query: {
                    apiId: 'membershipPointsPlans',
                    apiExtend: 'showList',
                    apiData: { isEarn: true }
                }
            }).then(res => {
                if (res.success) {
                    setMembershipPointsPlansData(res.data);;
                }
            });
        fetchApi.GET(defaultService,
            {
                query: {
                    apiId: 'membershipType',
                    apiExtend: 'showList'
                }
            }).then(res => {
                if (res.success) {
                    setMembershipTypeData(res.data);
                }
            });
        fetchApi.GET(defaultService,
            {
                query: {
                    apiId: 'membershipRechargeLockRules',
                    apiExtend: 'showList'
                }
            }).then(res => {
                if (res.success) {
                    setMembershipRechargeLockRulesData(res.data);;
                }
            })
    }, []);

    let extendProps: WebEditUniversalProps = {
        ...props,
        form,
        apiId,
        serviceId: 'business',
        dateOptions: {
            columnNames: ['startDate', 'endDate']
        },
        displayOptions: {
            width: 1000
        },
        formOptions: {
            instance: form,
            children: (<Row gutter={[8, 0]}>
                <Col span={4}>
                    <Form.Item
                        label="ID"
                        name="id">
                        <Input disabled={true} />
                    </Form.Item>
                </Col>

                <Col span={8}>
                    <Form.Item
                        label="方案"
                        name="planName"
                        rules={[{ required: true, message: '方案名称!' }]}>
                        <Input />
                    </Form.Item>
                </Col>

                <Col span={6}>
                    <Form.Item
                        label="类别"
                        name="membershipTypeId"
                        rules={[{ required: true, message: '请选择类别!' }]}>
                        <Select
                            showSearch
                            placeholder="类别"
                            onChange={(e) => {
                                form.setFieldValue('updateToMembershipLevelId', null);
                                getMembershipLevelData(e,
                                    defaultService,
                                    setMembershipLevelData
                                );
                            }}
                            optionFilterProp="children"
                            filterOption={(input, option: any) =>
                                option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}>
                            {getList.general(membershipTypeData, { itemName: 'typeName' })}
                        </Select>
                    </Form.Item>
                </Col>

                <Col span={6}>
                    <Form.Item
                        label="​充值类别"
                        name="rechargeCategoryId"
                        tooltip='自定金额客户可自输入充值金额'>
                        <Select
                            showSearch
                            placeholder="​充值类别"
                            optionFilterProp="children"
                            filterOption={(input, option: any) =>
                                option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}>
                            {getList.general(rechargeCategoryData)}
                        </Select>
                    </Form.Item>
                </Col>

                <Col span={7}>
                    <Form.Item
                        label="起始日期"
                        name="startDate"
                        tooltip='充值方案的起始日期'>
                        <DatePicker
                            disabled={permanentUseDisabled}
                            format="YYYY-MM-DD HH:mm:ss" />
                    </Form.Item>
                </Col>

                <Col span={7}>
                    <Form.Item
                        label="结束日期"
                        name="endDate"
                        tooltip='充值方案的结束日期'>
                        <DatePicker
                            disabled={permanentUseDisabled}
                            format="YYYY-MM-DD HH:mm:ss" />
                    </Form.Item>
                </Col>

                <Col span={5}>
                    <Form.Item
                        label="已用"
                        name="usedCopies"
                        tooltip='方案已用份数'>
                        <InputNumber
                            disabled={editMode === 'NEW' ? true : false}
                            style={{ width: 130 }} />
                    </Form.Item>
                </Col>

                <Col span={5}>
                    <Form.Item
                        label="总数"
                        name="totalCopies"
                        tooltip='方案的总份数' >
                        <InputNumber
                            disabled={permanentUseDisabled}
                            style={{ width: 130 }} />
                    </Form.Item>
                </Col>

                <Col span={4}>
                    <Form.Item
                        label="充值"
                        name="depositBalance"
                        tooltip='充值金额，自定充值不能低于当前设定金额'>
                        <InputNumber style={{ width: 95 }} />
                    </Form.Item>
                </Col>

                <Col span={4}>
                    <Form.Item
                        label="赠送"
                        name="grantGifts"
                        tooltip='充值成功后获取的赠送'>
                        <InputNumber style={{ width: 95 }} />
                    </Form.Item>
                </Col>

                <Col span={4}>
                    <Form.Item
                        label="延长"
                        name="extendGiftExpiry"
                        tooltip='延长赠送有效期(天)'>
                        <InputNumber style={{ width: 95 }} />
                    </Form.Item>
                </Col>

                <Col span={7}>
                    <Form.Item
                        label="积分方案"
                        name="membershipPointsPlansId">
                        <Select
                            showSearch
                            placeholder="积分"
                            optionFilterProp="children"
                            filterOption={(input, option: any) =>
                                option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}>
                            {getList.general(membershipPointsPlansData,
                                {
                                    itemName: 'planName',
                                    includeNull: true
                                })}
                        </Select>
                    </Form.Item>
                </Col>

                <Col span={5}>
                    <Form.Item
                        label="级别"
                        name="updateToMembershipLevelId"
                        tooltip='充值成功后，升级到当前级别'>
                        <Select
                            showSearch
                            placeholder="级别"
                            optionFilterProp="children"
                            filterOption={(input, option: any) =>
                                option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}>
                            {getList.general(membershipLevelData,
                                {
                                    itemName: 'levelName',
                                    includeNull: true
                                })}
                        </Select>
                    </Form.Item>
                </Col>

                <Col span={6}>
                    <Form.Item
                        label="锁定规则"
                        name="membershipRechargeLockRulesId">
                        <Select
                            showSearch
                            placeholder="锁定规则"
                            optionFilterProp="children"
                            filterOption={(input, option: any) =>
                                option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}>
                            {getList.general(membershipRechargeLockRulesData,
                                {
                                    itemName: 'ruleName',
                                    includeNull: true
                                })}
                        </Select>
                    </Form.Item>
                </Col>

                <Col span={3}>
                    <Form.Item
                        label="排序"
                        name="sorting"
                        tooltip='排序，数字小排前面'>
                        <InputNumber style={{ width: 50 }} />
                    </Form.Item>
                </Col>

                <Col span={3}>
                    <Form.Item
                        label="新客"
                        name="isExclusiveToNewCustomers"
                        tooltip='新客专用'
                        valuePropName="checked"
                        initialValue={false}>
                        < Switch checked={false}
                            checkedChildren="是"
                            unCheckedChildren="否" />
                    </Form.Item>
                </Col>

                <Col span={3}>
                    <Form.Item
                        label="退款"
                        name="isAllowRefunds"
                        tooltip='当前方案是否充许退款'
                        valuePropName="checked"
                        initialValue={true}>
                        < Switch checked={true}
                            checkedChildren="是"
                            unCheckedChildren="否" />
                    </Form.Item>
                </Col>

                <Col span={3}>
                    <Form.Item
                        label="显示"
                        name="isShow"
                        valuePropName="checked"
                        initialValue={true}>
                        < Switch checked={true}
                            checkedChildren="是"
                            unCheckedChildren="否" />
                    </Form.Item>
                </Col>

                <Col span={3}>
                    <Form.Item
                        label="永久"
                        name="isPermanentUse"
                        tooltip='方案永久使用'
                        valuePropName="checked"
                        initialValue={false}>
                        < Switch
                            onChange={(e) => {
                                setPermanentUseDisabled(e);
                            }}
                            checked={false}
                            checkedChildren="是"
                            unCheckedChildren="否" />
                    </Form.Item>
                </Col>

                <Col span={3}>
                    <Form.Item
                        label="状态"
                        name="isUse"
                        valuePropName="checked"
                        initialValue={true}>
                        < Switch checked={true}
                            checkedChildren="启用"
                            unCheckedChildren="关闭" />
                    </Form.Item>
                </Col>

                <Col span={24}>
                    <Form.Item
                        label="备注"
                        name="remarks">
                        < Input.TextArea autoSize={{ minRows: 2, maxRows: 10 }} />
                    </Form.Item>
                </Col>

            </Row>)
        }
    };

    return (<WebEditUniversal ref={ref} {...extendProps} />)
}

export default EditComponent;